import React from "react";
import { Link } from "react-router-dom";
import "./PressCTA.css";
import { useLanguage } from "../../contexts/LanguageContext";

export default function PressCTA({
  to = "/press",
  title,
  subtitle,
  ctaText,
  className = ""
}) {
  const { translations: t } = useLanguage();
  
  const defaultTitle = title || t?.pressCTA?.title || "Press & Brand Assets";
  const defaultSubtitle = subtitle || t?.pressCTA?.subtitle || "Grab official logos, icons, and brand guidelines.";
  const defaultCtaText = ctaText || t?.pressCTA?.ctaText || "Open Press Center";

  return (
    <section className={`presscta-simple ${className}`}>
      <div className="presscta-simple__content">
        <h3 className="presscta-simple__title">{defaultTitle}</h3>
        <p className="presscta-simple__subtitle">{defaultSubtitle}</p>
        <Link to={to} className="presscta-simple__btn" aria-label={defaultCtaText}>
          {defaultCtaText}
        </Link>
      </div>
    </section>
  );
}
